<template>
    <div v-loading="loading">
        <div>
            <div class="flex sortUpDown">
                <div class="sort" v-for="(sort,index) in sortList" :key="index" :style="{'color':(sortActive == index)? '#E1251B' : '#969696'}" @click="sortClick(sort,index)">
                    <p>{{sort.name}}
                        <img v-if="(sort.i == 0 || sort.i == 1)&& index != 0" src="../../../assets/xia.png" alt="">
                        <img v-if="sort.i == 2 && index != 0" src="../../../assets/shang.png" alt="">
                    </p>
                </div>
            </div>
            <div class="search">
                <input class="search-input" type="text" v-model="sub" placeholder="请输入关键词，比如采购名称、采购企业名称等">
                <p class="search-t" @click="search">搜索</p>
            </div>
        </div>
        <div class="esNotice">
            <div class="notice" @mouseenter="jMover(index)" @mouseleave="jShow = -1"
                 v-for="(demand,index) in zbDemandList" :key="index" @click="goProjectDetail(demand.id,demand.type)">
                <div class="notice_top">
                    <p class="notice_top_name">{{demand.projectName}}</p>
                    <div class="notice_top_type">
                        <p style="color:#FF6600;margin-left:-5px;">【{{demand.moduleType}}】</p>
                    </div>
                    <img src="../../../assets/xunjiazhong.png" alt="">
                </div>
                <div class="notice_cen">
                    <template v-if="demand.moduleType == '材料采购'">
                        <el-table :data="demand.goodsList" key="clcg">
                            <el-table-column label="材料名称" width="170" show-overflow-tooltip>
                                <template slot-scope="scope" >{{scope.row[0].value? scope.row[0].value : '/'}}</template>
                            </el-table-column>
                            <el-table-column label="规格型号" prop="ggxh" width="170" show-overflow-tooltip>
                                <template slot-scope="scope">{{scope.row[1].value? scope.row[1].value : '/'}}</template>
                            </el-table-column>
                            <el-table-column label="使用时间" prop="syshijian" width="120" show-overflow-tooltip>
                                <template slot-scope="scope">{{scope.row[2].value | formatDay}}</template>
                            </el-table-column>
                            <el-table-column label="采购量" width="80" show-overflow-tooltip>
                                <template slot-scope="scope">{{scope.row[3].value? scope.row[3].value : '/'}}</template>
                            </el-table-column>
                        </el-table>
                    </template>
                    <template v-if="demand.moduleType == '机械租赁'">
                        <el-table :data="demand.goodsList" key="jxzl">
                            <el-table-column label="机械名称" width="170" show-overflow-tooltip>
                                <template slot-scope="scope">{{scope.row[0].value? scope.row[0].value : '/'}}</template>
                            </el-table-column>
                            <el-table-column label="规格型号" prop="ggxh" width="170" show-overflow-tooltip>
                                <template slot-scope="scope">{{scope.row[1].value? scope.row[1].value : '/'}}</template>
                            </el-table-column>
                            <el-table-column label="使用时间" prop="syshijian" width="120" show-overflow-tooltip>
                                <template slot-scope="scope">{{scope.row[2].value | formatDay}}</template>
                            </el-table-column>
                            <el-table-column label="租赁量" width="80" show-overflow-tooltip>
                                <template slot-scope="scope">{{scope.row[3].value? scope.row[3].value : '/'}}</template>
                            </el-table-column>
                        </el-table>
                    </template>
                    <template v-if="demand.moduleType == '设备租赁'">
                        <el-table :data="demand.goodsList" key="sbzl">
                            <el-table-column label="设备名称" width="170" show-overflow-tooltip>
                                <template slot-scope="scope">{{scope.row[0].value? scope.row[0].value : '/'}}</template>
                            </el-table-column>
                            <el-table-column label="规格型号" prop="ggxh" width="170" show-overflow-tooltip>
                                <template slot-scope="scope">{{scope.row[1].value? scope.row[1].value : '/'}}</template>
                            </el-table-column>
                            <el-table-column label="使用时间" prop="syshijian" width="120" show-overflow-tooltip>
                                <template slot-scope="scope">{{scope.row[2].value | formatDay}}</template>
                            </el-table-column>
                            <el-table-column label="租赁量" width="80" show-overflow-tooltip>
                                <template slot-scope="scope">{{scope.row[3].value? scope.row[3].value : '/'}}</template>
                            </el-table-column>
                        </el-table>
                    </template>
                    <template v-if="demand.moduleType == '劳务用工' || demand.moduleType == '分包计划'">
                        <el-table :data="demand.goodsList" key="other">
                            <el-table-column label="工程名称" width="180" show-overflow-tooltip>
                                <template slot-scope="scope">{{scope.row[0].value? scope.row[0].value : '/'}}</template>
                            </el-table-column>
                            <el-table-column label="开工时间" prop="syshijian" width="180" show-overflow-tooltip>
                                <template slot-scope="scope">{{scope.row[1].value | formatDay}}</template>
                            </el-table-column>
                            <el-table-column label="工程量" width="180" show-overflow-tooltip>
                                <template slot-scope="scope">{{scope.row[2].value? scope.row[2].value : '/'}}</template>
                            </el-table-column>
                        </el-table>
                    </template>
                </div>
                <div class="notice_bot">
                    <div class="notice_bot_meg" style="margin-bottom:5px;">
                        <p class="key">发布时间：</p>
                        <p class="val">{{demand.createTime | formaHoures}}</p>
                    </div>
                    <div class="notice_bot_meg" style="margin-bottom:5px;">
                        <p class="key">发布单位：</p>
                        <p class="val1">{{demand.applyCompanyName}}</p>
                    </div>
                    <div class="notice_bot_meg">
                        <img src="../../../assets/location.png" alt="" class="img">
                        <p class="key">地址：</p>
                        <p class="val1">{{demand.addrDetail}}</p>
                    </div>
                </div>
                <jPop
                v-if="index == jShow"
                :type="num"
                :item="demand"
                ></jPop>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  components: {
    jPop: () => import("@/components/zhaocai/jPop")
  },
  props: {
    zbDemandList: {
      type: Array,
      required: true
    },
    serchWord: {
      type: Number,
      required: true
    },
    loading: {
      type: Boolean
    }
  },

  data() {
    return {
      sortList: [
        {
          name: "综合排序",
          no: 1,
          demo: true,
          i: 0
        },
        {
          name: "发布时间",
          no: 2,
          demo: true,
          i: 0
        },
        {
          name: "距离",
          no: 3,
          demo: true,
          i: 0
        }
      ],
      sortActive: 0,
      params: {
        sortMethod: 1,
        localLng: 0,
        localLat: 0
      },
      sub: "",
      jShow: -1,
      num: 5
    };
  },
  mounted() {},
  created() {},
  watch: {
    serchWord: {
      handler(newObj, oldObj) {
        this.sub = "";
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    jMover(i) {
      this.jShow = i;
    },
    goProjectDetail(id, type) {
      let param = `${process.env.VUE_APP_ZHAOCAI}/demandEsDetail?id=${id}&type=${type}`;
      window.open(param);
    },
    search() {
      this.params.keyword = this.sub;
      this.$emit("sortChange", this.params);
    },
    //排序方式
    sortClick(sort, index) {
      let currentMeg = JSON.parse(localStorage.getItem("position"));
      this.sortActive = index;
      if (index == 0) {
        this.params.sortMethod = 1;
        this.sortList[1].i = 0;
        this.sortList[2].i = 0;
      } else if (index == 1) {
        this.sortList[1].i++;
        if (this.sortList[1].i > 2) {
          this.sortList[1].i = 1;
        }
        if (this.sortList[1].i == 0 || this.sortList[1].i == 1) {
          this.params.sortMethod = 3;
        } else {
          this.params.sortMethod = 2;
        }
        this.sortList[2].i = 0;
      } else if (index == 2) {
        this.params.sortMethod = 4;
        this.sortList[1].i = 0;
        this.sortList[2].i = 0;
        this.params.localLng = currentMeg.lng;
        this.params.localLat = currentMeg.lat;
      }
      this.$emit("sortChange", this.params);
    }
  }
};
</script>
<style lang="scss" scoped>
.sortUpDown {
  width: 1198px;
  background: #fff;
  height: 20px;
  padding: 10px 0;
  border: 1px solid #e4e7ed;
  border-bottom: none;
  .sort {
    width: 100px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    background: white;
    font-size: 15px;
    border-right: 1px solid #e4e7ed;
    cursor: pointer;
    &:last-child {
      border-right: none;
    }
  }
}
.flex {
  display: flex;
}
.esNotice {
  width: 1158px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  padding: 10px 20px 0 20px;
  border: 1px solid #e4e7ed;
  border-top: none;
  .notice {
    width: 567px;
    height: 335px;
    border: 1px solid #e4e7ed;
    margin-right: 20px;
    margin-bottom: 20px;
    &:nth-child(even) {
      margin-right: 0;
    }
    &:hover {
      border: 1px solid #b79255;
      transform: translateY(-20px);
      transition: all 0.2s ease-in-out;
    }
    .notice_top {
      width: 547px;
      height: 40px;
      padding: 15px 10px;
      background: #f5f7fa;
      position: relative;
      .notice_top_name {
        width: 450px;
        font-size: 16px;
        line-height: 16px;
        color: #333;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-bottom: 5px;
      }
      .notice_top_type {
        font-size: 14px;
        display: flex;
      }
      img {
        position: absolute;
        right: 0;
        top: 0;
      }
    }
    .notice_cen {
      margin: 0 10px;
      height: 152px;
      overflow: hidden;
      border-bottom: 1px dashed #e4e7ed;
    }
    .notice_bot {
      padding: 20px 10px 10px 10px;
      .notice_bot_meg {
        font-size: 14px;
        display: flex;
        margin-bottom: 10px;
        :last-child {
          margin-bottom: none;
        }
        .img {
          width: 14px;
          height: 14px;
          margin-top: 3px;
        }
        .key {
          color: #666;
        }
        .val {
          line-height: 21px;
          color: #969696;
        }
        .val1 {
          line-height: 21px;
          color: #333;
          width: 425px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        img {
          width: 14px;
          height: 17px;
          margin-right: 5px;
        }
      }
    }
  }
}
.search {
  display: flex;
  padding: 9px 20px;
  border: 1px solid #e4e7ed;
  border-bottom: none;
  .search-input {
    width: 300px;
    height: 30px;
    padding: 0 5px;
    background: #ffffff;
    border: 1px solid #e4e7ed;
    color: #333;
    outline: none;
  }
  /deep/::-webkit-input-placeholder {
    color: #c0c4cc;
  }
  .search-t {
    margin-left: 20px;
    width: 54px;
    cursor: pointer;
    text-align: center;
    background: #e1251b;
    color: white;
    line-height: 30px;
    font-size: 15px;
  }
}
/deep/.notice_cen .el-table td {
  padding: 7px 0;
  border: 0;
}
/deep/.notice_cen .el-table th {
  padding: 7px 0;
  border: 0;
}
/deep/.el-table:before {
  height: 0;
}
/deep/.el-table .cell {
  color: #333333 !important;
}
/deep/.el-table .el-table__row .cell {
  color: #666666 !important;
}
</style>
